import {Component} from 'react';
import h from 'react-hyperscript';
import './SidebarItem.scss';
import {subhead} from 'Components/Typography/Typography';
import Image from 'Components/Image/Image';

class SidebarItem extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.initialRemainingClasses = 'footnote text--grey remaining-indicator';
    this.state = {
      mountedClass: 'inactive',
      isActive: false,
      isDisabled: false,
      isComplete: false,
    };
  }

  componentWillMount() {
    this._isMounted = true;
    this.checkStatus();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setMountedClass();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.checkStatus();
    }
  }

  setMountedClass() {
    let value;
    if (this.state.isActive) {
      value = 'active';
      if (this.state.isComplete) {
        value += ' complete';
      }
    } else if (this.state.isDisabled) {
      value = 'disabled';
    } else if (this.state.isComplete) {
      value = 'complete';
    } else {
      value = 'inactive';
    }

    this.setState({
      mountedClass: value,
    });
  }

  checkStatus() {
    const {isActive, step, completedSteps, id} = this.props;
    if (isActive) {
      this.setIsActive(true);
    } else {
      this.setIsActive(false);
    }

    if (step > completedSteps.length) {
      this.setIsDisabled(true);
    } else {
      this.setIsDisabled(false);
    }

    if (completedSteps.includes(`${id}Values`)) {
      this.setIsComplete(true);
    } else {
      this.setIsComplete(false);
    }
  }

  setIsActive(value) {
    this.setState(
        {
          isActive: value,
        },
        () => {
          this.setMountedClass();
        }
    );
  }

  setIsDisabled(value) {
    this.setState(
        {
          isDisabled: value,
        },
        () => {
          this.setMountedClass();
        }
    );
  }

  setIsComplete(value) {
    this.setState(
        {
          isComplete: value,
        },
        () => {
          this.setMountedClass();
        }
    );
  }

  getRemaining() {
    const {fieldValues} = this.props;
    const idValues = `${this.props.id}Values`;
    if (
      fieldValues &&
      fieldValues[idValues] &&
      fieldValues[idValues].elementComplete
    ) {
      return fieldValues[idValues].elementComplete.total -
        fieldValues[idValues].elementComplete.answered;
    } else {
      return null;
    }
  }

  render() {
    const {id, icon, name, classes, step, onClick} = this.props;
    const {mountedClass, isDisabled} = this.state;
    const remaining = this.getRemaining();
    const remainingClasses = !isDisabled && remaining ?
    'active' : '';

    return h(
        'li',
        {
          key: `${id}-sidebar__key`,
          step: step,
          className: `${classes} ${mountedClass}`,
          onClick: onClick,
        },
        [
          h(
              'div',
              {
                key: `${id}-sidebar-title-container__key`,
                className: 'sidebar__step__container',
              },
              [
                h(
                    'div',
                    {
                      className: 'flex',
                    },
                    [
                      h(
                          Image,
                          {
                            key: `${id}-title-icon__key`,
                            src: icon,
                            className: 'padding-right--micro sidebar-icon',
                            alt: `${name} Icon`,
                          },
                          null
                      ),
                      h(
                          subhead,
                          {
                            key: `${id}-title__key`,
                            className: 'col-ratio-2',
                          },
                          name
                      ),
                      h(
                          'span',
                          {
                            key: `${id}-complete__key`,
                            className: 'material-icons icon--complete',
                          },
                          'check'
                      ),
                    ]
                ),

                h(
                    'p',
                    {
                      className: `
                        ${this.initialRemainingClasses} ${remainingClasses}
                      `,
                    },
                    `${remaining} Incomplete`
                ),
              ]
          ),
        ]
    );
  }
}

export default SidebarItem;
